import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[y42ScrollSpy]',
})
export class ScrollSpyDirective {
  constructor(private readonly _el: ElementRef) {}
  @Input() public spiedTags: string[] = [];
  @Output() public sectionChange = new EventEmitter<string>();
  private currentSection = '';

  @HostListener('scroll', ['$event'])
  // FIXME hardcoded event interface because I cannot find the right one
  onScroll(event: { target: { scrollTop: number; offsetTop: number } }) {
    let currentSection = '';
    const children = this._el.nativeElement.children;
    const scrollTop = event.target?.scrollTop;
    const parentOffset = event.target?.offsetTop;
    for (let i = 0; i < children.length; i++) {
      const element = children[i];
      if (this.spiedTags.some((spiedTag) => spiedTag === element.tagName)) {
        if (element.offsetTop - parentOffset <= scrollTop) {
          currentSection = element.id;
        }
      }
    }
    if (currentSection !== this.currentSection) {
      this.currentSection = currentSection;
      this.sectionChange.emit(this.currentSection);
    }
  }
}
